/** Uploaded file videos: cap size, let native aspect ratio show (no forced square). */
export const CHAT_VIDEO_PLAYER_SHELL_STYLE = {
  position: "relative",
  width: "fit-content",
  maxWidth: "300px",
  maxHeight: "290px",
  borderRadius: "20px",
  overflow: "hidden",
  backgroundColor: "black",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,
};

/** Pasted YouTube / hosted links: landscape 16:9 (explicit width so shell does not collapse). */
export const CHAT_VIDEO_EMBED_SHELL_STYLE = {
  position: "relative",
  width: "300px",
  maxWidth: "100%",
  borderRadius: "20px",
  overflow: "hidden",
  backgroundColor: "black",
  display: "block",
  flexShrink: 0,
};
